import { render, staticRenderFns } from "./suporte-caixas-cirurgicas.vue?vue&type=template&id=305a56ec"
import script from "./suporte-caixas-cirurgicas.vue?vue&type=script&lang=ts"
export * from "./suporte-caixas-cirurgicas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports